import React, { type ReactElement } from 'react';
import { capitalize } from 'lodash';
import { useFormContext } from 'react-hook-form';
import SubmitButton from 'atom-components/form-fields-for-hook-form/submit-button';
import { SubmitAction } from './marking-group-form.schema';

export default function SaveButton({ isSaving }: { isSaving: boolean }): ReactElement {
  const { formState, getValues } = useFormContext();

  const { isSubmitting } = formState;
  const submittingOrSaving = isSubmitting || isSaving;

  const submitAction = getValues('submitAction');

  return (
    <SubmitButton disabled={submittingOrSaving}>
      {submittingOrSaving
        ? `${submitAction === SubmitAction.Update ? 'Updating' : 'Creating'} Marking Group...`
        : `${capitalize(submitAction)} Marking Group`}
    </SubmitButton>
  );
}
